import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { SafeUrl } from '@angular/platform-browser';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../../components/icon/icon.component';
import { BtnComponent } from '../../../../components/btn/btn.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserdataService } from '../../../../service/userdata.service';
import { User } from '../../../../lib/interfaces/user';
import { Company } from '../../../../lib/interfaces/company';
import { CompaniesService } from '../../../../service/companies.service';


@Component({
    selector: 'app-avatar-edit',
    templateUrl: './avatar-edit.component.html',
    styleUrls: ['./avatar-edit.component.scss'],
    standalone: true,
    imports: [ImageCropperComponent, CommonModule, IconComponent, BtnComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AvatarEditComponent {
    imageChangedEvent: Event | null = null;
    croppedImage: SafeUrl = '';
    imageFile: File | undefined = undefined;
    showWrongFileType: boolean = false;

    public data = inject<User | Company>(MAT_DIALOG_DATA);
    private dialogRef = inject(MatDialogRef<AvatarEditComponent>);
    private userService = inject(UserdataService);
    private companyService = inject(CompaniesService);

    fileChangeEvent(event: Event): void {
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        if (event.base64) {
            this.croppedImage = event.base64;
        }
    }
    onDragOver(event: any) {
        event.preventDefault();
    }
    onDropSuccess(event: any) {
        event.preventDefault();
        this.showWrongFileType = false;
        if (event.dataTransfer?.files?.length > 0) {

            if (event.dataTransfer.files[0].type.match(/image\/*/) == null) {
                this.showWrongFileType = true;
                return;
            }
            this.imageFile = event.dataTransfer.files[0];
            this.imageChangedEvent = new Event('fileSelected');
        }
    }
    close() {
        this.dialogRef.close();
    }
    async save(): Promise<void> {
        if (this.croppedImage) {
            let result = false;

            console.log(this.isUser(this.data))
            if (this.isUser(this.data)) {
                result = await this.userService.uploadAvatar(this.croppedImage);
            } else {
                if(!this.data.companyId) {
                    this.dialogRef.close(this.croppedImage);
                } else {
                    result = await this.companyService.uploadLogo(<string>this.croppedImage, this.data.companyId);
                }
            }

            if (result) {
                this.dialogRef.close();
            }
        }
    }

    protected isUser(data: User | Company): data is User {
        return (<User>data).lastLogin !== undefined;
    }
}

